import { Dictionary } from "@insite/client-framework/Common/Types";
import { useEffect, useState } from "react";

const data: Dictionary<string[]> = {};

export default (key: string, uniqueId: string | undefined) => {
    if (!data[key]) {
        data[key] = [];
    }

    const [isDuplicate] = useState(!(!uniqueId || (!data[key]?.includes(uniqueId) && data[key].push(uniqueId))));

    useEffect(() => {
        return () => {
            if (uniqueId) {
                const index = data[key].indexOf(uniqueId);

                if (index >= 0) {
                    data[key].splice(index, 1);
                }
            }
        };
    }, []);

    return isDuplicate;
};
